// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"faec01fe","93":"b0c0beb9","292":"98f13687","341":"b30e58f6","427":"1ed2ba46","505":"21f80b48","519":"7710ccac","566":"ba13f076","770":"038f162e","836":"404c520c","904":"ce0f5949","952":"b156b9b2"}[chunkId] + ".chunk.js";
};